import http from "../../../../../core/utils/apis/skillApi";

const getAllCertificationRequests = async () => {
  try {
    const response = await http.get("/skill-requests-certified");
    console.log("📌 Fetched Certification Requests:", response.data);
    return response.data;
  } catch (e) {
    console.error("❌ Error fetching certification requests:", e.response?.data || e);
    throw e;
  }
};

const getCertificationRequestById = async (certificationId) => {
  try {
    const response = await http.get(`/skill-requests-certified/${certificationId}`);
    console.log("📌 Fetched Certification Request:", response.data);
    return response.data;
  } catch (e) {
    console.error("❌ Error fetching certification request:", e.response?.data || e);
    throw e;
  }
};

const approveCertificationRequest = async (certificationId, approverId) => {
  try {
    const response = await http.patch(`/skill-requests-certified/${certificationId}/approve`, {
      validatedBy: approverId, // ✅ Correction ici !
    });

    console.log("✅ Certification Approved:", response.data);
    return response.data;
  } catch (e) {
    console.error("❌ Error approving certification request:", e.response?.data || e);
    throw e;
  }
};

const rejectCertificationRequest = async (certificationId, approverId) => {
  try {
    const response = await http.patch(`/skill-requests-certified/${certificationId}/reject`, {
      validatedBy: approverId, 
    });

    console.log("❌ Certification Rejected:", response.data);
    return response.data;
  } catch (e) {
    console.error("❌ Error rejecting certification request:", e.response?.data || e);
    throw e;
  }
};
const getCertificateUrl = async (certId) => {
  try {
    const response = await http({
      method: "GET",
      url: `/skill-requests-certified/${certId}/download-cert`,
      responseType: "blob", 
    });

    if (!response.data || response.data.size === 0) {
      console.error("❌ Error: The downloaded file is empty or corrupted.");
      return null;
    }

    const file = new Blob([response.data], { type: response.headers["content-type"] });
    return URL.createObjectURL(file); // 📌 Générer un URL temporaire sans téléchargement automatique
  } catch (e) {
    console.error("❌ Error fetching certificate:", e.response?.data || e);
    return null;
  }
};

const downloadCertificate = async (certId) => {
  try {
    const response = await http({
      method: "GET",
      url: `/skill-requests-certified/${certId}/download-cert`,
      responseType: "blob", // 📌 Récupère le fichier en binaire
    });

    if (!response.data || response.data.size === 0) {
      console.error("❌ Error: The downloaded file is empty or corrupted.");
      return;
    }

    const contentType = response.headers["content-type"];
    const fileExtension = contentType.includes("pdf") ? "pdf" : "jpg";
    const file = new Blob([response.data], { type: contentType });

    // 📌 Création d'un lien temporaire pour le téléchargement
    const link = document.createElement("a");
    link.href = URL.createObjectURL(file);
    link.setAttribute("download", `certificate-${certId}.${fileExtension}`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  } catch (e) {
    console.error("❌ Error downloading certificate:", e.response?.data || e);
  }
};
const CertificationRequestService = {
  getAllCertificationRequests,
  getCertificationRequestById,
  approveCertificationRequest,
  rejectCertificationRequest,
  downloadCertificate,
  getCertificateUrl
};

export default CertificationRequestService;
